export const MODAL_HIDDEN = 'HIDE_MODAL';

export const modalHidden = () => dispatch =>
  dispatch({
    type: MODAL_HIDDEN,
  });
